<template>
  <v-tooltip top v-if="oferta.possuiVariacao">
    <template v-slot:activator="{ on }">
      <v-icon small v-on="on" color="secondary">mdi-grid</v-icon>
    </template>
    <span>Esta oferta possui grade de variação</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    oferta: Object,
  },
};
</script>
